import { render, staticRenderFns } from "./TokenDetails.vue?vue&type=template&id=e66198b2&"
import script from "./TokenDetails.vue?vue&type=script&lang=js&"
export * from "./TokenDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports